<div class="error-dialog">
  <div class="error-dialog__header">
    <h1 class="error-dialog__title">{{ title }}</h1>
  </div>
  <div class="error-dialog__content">
    <p class="error-dialog__message">{{ message }}</p>
  </div>
  <div class="error-dialog__actions">
    <button class="btn-primary" type="button" (click)="dialogRef.close('OK')">OK</button>
  </div>
</div>